<template>
  <div class="container">
    <h1 class="title">{{ title }}</h1>
    <h1 class="subtitle">
      <span class="title is-5">{{ empresa.nombrec }}</span>
      <small class="title is-6"
        >{{ empresa.nit | textnumber() }}{{ empresa.nit | dverif() }}</small
      >
      <small class="subtitle is-7">{{ empresa.nombre }}</small>
    </h1>

    <hr />
    <div style="margin-top: 32px; margin-bottom: 32px">
      <router-link
        class="button is-light is-medium"
        :to="{ name: 'configurations.document' }"
      >
        <span class="icon is-small">
          <span class="material-icons">list</span>
        </span>
        <span>Lista</span> </router-link
      >˝
    </div>
    <div class="columns is-multiline">
      <div class="column is-4" v-if="visibility.nombre">
        <div class="field">
          <label class="label">Nombre</label>
          <div class="control">
            <input
              v-model="comprobante.nombre"
              class="input"
              type="text"
              placeholder="Nombre"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.codigo">
        <div class="field">
          <label class="label">Código</label>
          <div class="control">
            <input
              v-model="comprobante.codigo"
              class="input"
              type="text"
              placeholder="Código"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.consecutivo">
        <div class="field">
          <label class="label">Consecutivo módulo comercial</label>
          <div class="control">
            <input
              v-model="comprobante.consecutivo"
              class="input"
              type="number"
              placeholder="Consecutivo"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.consecutivo">
        <div class="field">
          <label class="label">Consecutivo módulo contable</label>
          <div class="control">
            <input
              v-model="comprobante.consecutivoc"
              class="input"
              type="number"
              placeholder="Consecutivo"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.estructura1">
        <div class="field">
          <label class="label">Estructura</label>
          <div class="select is-fullwidth">
            <select
              v-model="comprobante.estructura1"
              @change="estruct(comprobante.estructura1)"
            >
              <option value>Estructura</option>
              <option value="comercial">Comercial</option>
              <option value="comercialfra">Factura Comercial</option>
              <option value="factura">Factura Pvta</option>
              <option value="inventario">Inventario</option>
              <option value="contable">Contable</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.nocontable">
        <div class="field">
          <label class="label">Es Contable</label>
          <div class="select is-fullwidth">
            <select v-model="comprobante.nocontable">
              <option :value="true">No</option>
              <option :value="false">Si</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.cuenta">
        <div class="field">
          <label class="label">Contrapartida</label>
          <div class="select is-fullwidth">
            <select v-model="comprobante.cuenta">
              <option value>Cuenta</option>
              <option
                v-for="(cuenta, index) in cuentas1"
                :key="index"
                :value="cuenta._id"
              >
                {{ cuenta.codigo }} - {{ cuenta.nombre }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.tipo">
        <div class="field">
          <label class="label">Naturaleza Contrapartida</label>
          <div class="select is-fullwidth">
            <select v-model="comprobante.tipo">
              <option value>Naturaleza</option>
              <option value="1">Debito</option>
              <option value="2">Credito</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.titulo">
        <div class="field">
          <label class="label">Titulo en impresion de documento</label>
          <div class="control">
            <input
              v-model="comprobante.titulo"
              class="input"
              type="text"
              placeholder="Título"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.prefijo">
        <div class="field">
          <label class="label">Prefijo</label>
          <div class="control">
            <input
              v-model="comprobante.prefijo"
              class="input"
              type="text"
              placeholder="Prefijo"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.caracteres">
        <div class="field">
          <label class="label">Número de Caracteres</label>
          <div class="control">
            <input
              v-model="comprobante.caracteres"
              class="input"
              type="text"
              placeholder="# de caracteres"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.mensaje">
        <div class="field">
          <label class="label">Mensaje</label>
          <div class="control">
            <input
              v-model="comprobante.mensaje"
              class="input"
              type="text"
              placeholder="Mensaje"
            />
          </div>
        </div>
      </div>
      <div class="column is-4">
        <div class="field">
          <label class="label">Fecha automática</label>
          <div class="select is-fullwidth">
            <select v-model="comprobante.automaticdate">
              <option :value="false">No</option>
              <option :value="true">Si</option>
            </select>
          </div>
        </div>
      </div>

      <div class="column is-4" v-if="visibility.logo">
        <div class="field">
          <label class="label">Usar Logo en la Factura</label>
          <div class="select is-fullwidth">
            <select v-model="comprobante.logo">
              <option :value="false">No</option>
              <option :value="true">Si</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.vencimiento">
        <div class="field">
          <label class="label">Vencimiento</label>
          <div class="select is-fullwidth">
            <select v-model="comprobante.vencimiento">
              <option value="1">Contado</option>
              <option value="7">7 Días</option>
              <option value="15">15 Días</option>
              <option value="30">30 Días</option>
              <option value="45">45 Días</option>
              <option value="60">60 Días</option>
              <option value="90">90 Días</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.facturaresolucion">
        <div class="field">
          <label class="label">Resolución de Facturación</label>
          <div class="control">
            <input
              v-model="comprobante.factura.resolucion"
              class="input"
              type="text"
              placeholder="Resolución"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.resolucion">
        <div class="field">
          <label class="label">Resolución de Facturación</label>
          <div class="control">
            <input
              v-model="comprobante.resolucion"
              class="input"
              type="text"
              placeholder="Resolución"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.isElectronico">
        <div class="field">
          <label class="label">Envio de Información a la DIAN</label>
          <div class="select is-fullwidth">
            <select v-model="comprobante.isElectronico" disabled>
              <option :value="false">No</option>
              <option :value="true">Si</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="comprobante.isElectronico">
        <div class="field">
          <label class="label">Documento en modo de pruebas</label>
          <div class="select is-fullwidth">
            <select v-model="comprobante.isPrueba">
              <option :value="false">No</option>
              <option :value="true">Si</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="comprobante.isElectronico">
        <div class="field">
          <label class="label">Número de la Resolución</label>
          <div class="control">
            <input
              v-model="comprobante.resolucionelect"
              class="input"
              type="text"
              placeholder="Resolución"
            />
          </div>
        </div>
      </div>

      <div class="column is-4" v-if="comprobante.isElectronico">
        <div class="field">
          <label class="label">Fecha inicio de la Resolución</label>
          <div class="control">
            <input
              v-model="comprobante.resoluciodatestart"
              class="input"
              type="date"
              placeholder="Resolución"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="comprobante.isElectronico">
        <div class="field">
          <label class="label">Fecha final de la resolución</label>
          <div class="control">
            <input
              v-model="comprobante.resoluciodatefinal"
              class="input"
              type="date"
              placeholder="Resolución"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="comprobante.isElectronico">
        <div class="field">
          <label class="label">Rango Inicial facturación electrónica</label>
          <div class="control">
            <input
              v-model="comprobante.resolucionrangestart"
              class="input"
              type="text"
              placeholder="Resolución"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="comprobante.isElectronico">
        <div class="field">
          <label class="label">Rango Final facturación electrónica</label>
          <div class="control">
            <input
              v-model="comprobante.resolucionrangefinal"
              class="input"
              type="text"
              placeholder="Resolución"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="comprobante.isElectronico">
        <div class="field">
          <label class="label">Clave Técnica Factura Electrónica</label>
          <div class="control">
            <input
              v-model="comprobante.ctecnica"
              class="input"
              type="text"
              placeholder="Clave Técnica"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="comprobante.isElectronico">
        <div class="field">
          <label class="label">Id Factura Electrónica</label>
          <div class="control">
            <input
              v-model="comprobante.idfra"
              class="input"
              type="text"
              placeholder="Id Factura Electrónica"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="comprobante.isElectronico">
        <div class="field">
          <label class="label">Tipo de documento</label>
          <div class="select is-fullwidth">
            <select v-model="comprobante.tipodocumento">
              <option value>Factura</option>
              <option value="NC">Nota Crédito</option>
              <option value="ND">Nota Débito</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="comprobante.isElectronico">
        <div class="field">
          <label class="label">Mensaje Pie Factura</label>
          <div class="control">
            <input
              v-model="comprobante.factura.piefactura"
              class="input"
              type="text"
              placeholder="Pie Factura"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.negrita">
        <div class="field">
          <label class="label">Mensaje en Negrita</label>
          <div class="control">
            <input
              v-model="comprobante.negrita"
              class="input"
              type="text"
              placeholder="Mensaje"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.small">
        <div class="field">
          <label class="label">Mensaje en Letra Pequeña</label>
          <div class="control">
            <input
              v-model="comprobante.small"
              class="input"
              type="text"
              placeholder="Mensaje"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.letras">
        <div class="field">
          <label class="label">Incluir Total en Letras</label>
          <div class="select is-fullwidth">
            <select v-model="comprobante.letras">
              <option :value="false">No</option>
              <option :value="true">Si</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.cop">
        <div class="field">
          <label class="label">Incluir (COP) Antes del Signo Pesos</label>
          <div class="select is-fullwidth">
            <select v-model="comprobante.cop">
              <option :value="false">No</option>
              <option :value="true">Si</option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.t1">
        <div class="field">
          <label class="label">Título Cuadro 1</label>
          <div class="control">
            <input
              v-model="comprobante.t1"
              class="input"
              type="text"
              placeholder="Mensaje"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.t2">
        <div class="field">
          <label class="label">Título Cuadro 2</label>
          <div class="control">
            <input
              v-model="comprobante.t2"
              class="input"
              type="text"
              placeholder="Mensaje"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.t3">
        <div class="field">
          <label class="label">Título de Observaciones</label>
          <div class="control">
            <input
              v-model="comprobante.t3"
              class="input"
              type="text"
              placeholder="Mensaje"
            />
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.facturaNit">
        <div class="field">
          <label class="label">Tercero Predefinido</label>
          <div class="select is-fullwidth">
            <select v-model="comprobante.facturanit1">
              <option value>Tercero</option>
              <option
                v-for="(tercero, index) in nits"
                :key="index"
                :value="tercero._id"
              >
                {{ tercero.codigo }} - {{ tercero.nombre }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.facturaBodega">
        <div class="field">
          <label class="label">Bodega Predefinida</label>
          <div class="select is-fullwidth">
            <select v-model="comprobante.facturabodega1">
              <option value>Bodega</option>
              <option
                v-for="(bodega, index) in bodegas"
                :key="index"
                :value="bodega._id"
              >
                {{ bodega.codigo }} - {{ bodega.descripcion }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.facturaCcostos">
        <div class="field">
          <label class="label">C. Costos Predefinido</label>
          <div class="select is-fullwidth">
            <select v-model="comprobante.facturaccostos1">
              <option value>C Costos</option>
              <option
                v-for="(ccosto, index) in listaCCostos"
                :key="index"
                :value="ccosto._id"
              >
                {{ ccosto.codigo }} - {{ ccosto.nombre }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-4" v-if="visibility.facturaLprecios">
        <div class="field">
          <label class="label">Lista de Precios Predefinida</label>
          <div class="select is-fullwidth">
            <select v-model="comprobante.facturalprecios1">
              <option value>Lista de Precios</option>
              <option
                v-for="(lprecio, index) in lprecios"
                :key="index"
                :value="lprecio.codigo"
              >
                {{ lprecio.codigo }} - {{ lprecio.nombre }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div class="column is-12" v-if="comprobante.logo">
        <div class="field">
          <div class="file is-primary">
            <label class="file-label">
              <input
                class="file-input"
                type="file"
                accept=".png, .jpg, jpeg"
                @change="onFileChange"
                name="resume"
              />
              <span class="file-cta">
                <span class="file-icon">
                  <i class="material-icons">add_photo_alternate</i>
                </span>
                <span class="file-label">Seleccionar Imagen</span>
              </span>
            </label>
          </div>
        </div>
      </div>
      <progress
        v-show="avaceupload > 0"
        class="progress is-info is-small"
        :value="avaceupload"
        max="100"
      ></progress>
      <figure class="image is-128x128">
        <img v-show="urlimg" :src="urlimg" />
        <img v-show="!urlimg" :src="comprobante.urlimg" />
      </figure>
    </div>
    <div v-show="isedit" style="margin-bottom: 20px">
      <router-link
        v-if="visibility.cuentasdocumento"
        :to="{
          name: 'configurations.cuentadocument',
          params: { comprobanteid: this.$route.params.id },
        }"
        class="button is-light is-medium"
      >
        <span class="icon">
          <span class="material-icons">playlist_add</span>
        </span>
        <span>Agregar cuentas</span>
      </router-link>
      <button
        v-if="visibility.contrapartidasadicionales"
        class="button is-light is-medium"
        @click="clickshowcontrapartidas"
      >
        <span class="icon">
          <span class="material-icons">playlist_add</span>
        </span>
        <span>Agregar contrapartidas adicionales</span>
      </button>
      <br />
      <br />
      <div
        v-show="visibility.contrapartidasadicionales && showAddContrapartida"
        class="field has-addons"
      >
        <div class="control">
          <div class="select">
            <select v-model="contrapartidaSelected">
              <option value>Cuenta</option>
              <option
                v-for="(cuenta, index) in cuentas"
                :key="index"
                :value="cuenta"
              >
                {{ cuenta.codigo }} - {{ cuenta.nombre }}
              </option>
            </select>
          </div>
        </div>
        <div class="control">
          <button
            type="submit"
            class="button is-primary"
            @click="addContrapartida()"
          >
            Agregar
          </button>
        </div>
      </div>
    </div>
    <div
      v-if="visibility.contrapartidasadicionales && isedit"
      class="table-container"
    >
      <h1 class="title is-4">Contrapartidas</h1>
      <table class="table is-hoverable is-narrow is-fullwidth">
        <thead>
          <tr>
            <th style="width: 85px">Código</th>
            <th>Nombre</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(cuenta, index) in contrapartidas" :key="index">
            <td class="fontMono">
              <strong>{{ cuenta.codigo }}</strong>
            </td>
            <td>
              <input class="input" type="text" v-model="cuenta.nombre" />
            </td>
            <td>
              <span
                class="material-icons has-text-danger hand"
                @click="deleteContrapartida(cuenta._id)"
                >delete_forever</span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="visibility.cuentasdocumento && isedit" class="table-container">
      <h1 class="title is-4">Cuentas asignadas</h1>
      <table class="table is-hoverable is-narrow">
        <thead>
          <tr>
            <th>Código</th>
            <th>Nombre</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(cuenta, index) in cuentasdcto" :key="index">
            <td class="fontMono">
              <strong>{{ cuenta.cuenta.codigo }}</strong>
            </td>
            <td>{{ cuenta.nombrep }}</td>
            <td>
              <span
                class="material-icons has-text-danger hand"
                @click="deleteCuentadocumento(cuenta._id)"
                >delete_forever</span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="columns">
      <div class="column">
        <button class="button is-info is-medium" @click="saveDocumento">
          <span class="icon">
            <span class="material-icons">{{ iconbutton }}</span>
          </span>
          <span>{{ textbutton }}</span>
        </button>
        <router-link
          class="button is-medium"
          :to="{ name: 'configurations.document' }"
        >
          <span class="icon is-small">
            <span class="material-icons">cancel</span>
          </span>
          <span>Cancelar</span>
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import apiServices from "@/services/yungol-services";
import functions from "@/helpers/functions";
export default {
  data() {
    return {
      urlimg: "",
      avaceupload: 0,
      contrapartidaSelected: {},
      showAddContrapartida: false,
      textbutton: "",
      iconbutton: "",
      isedit: false,
      title: "Crear Documento",
      listaCCostos: [],
      comprobantes: [],
      lprecios: [],
      cuentasdcto: [],
      comprobante: {
        automaticdate: false,
        nocontable: false,
        nombre: "",
        codigo: "",
        consecutivo: 1,
        consecutivoc: 1,
        estructura1: "",
        estructura: "",
        cuenta: "",
        tipo: "",
        titulo: "",
        aux: false,
        prefijo: "",
        caracteres: "",
        mensaje: "",
        logo: false,
        vencimiento: 0,
        resolucion: "",
        negrita: "",
        small: "",
        letras: false,
        cop: false,
        tipodocumento: "",
        t1: "RECIBE",
        t2: "ATENTAMENTE",
        t3: "NOTA:",
        urlimg: "",
        factura: {
          nit: {},
          bodega: {},
          ccostos: {},
          lprecios: {},
          resolucion: "",
          piefactura: "",
          contrapartidas: [],
        },
        inventario: {
          contrapartidas: [],
        },
        resolucionelect: "",
        resoluciodatestart: "",
        resoluciodatefinal: "",
        resolucionrangestart: "",
        resolucionrangefinal: "",
        isElectronico: false,
        isPrueba: false,
        ctecnica: "",
        idfra: "",
      },
      visibility: {
        nombre: true,
        codigo: true,
        consecutivo: true,
        estructura1: true,
        estructura: true,
        cuenta: false,
        tipo: false,
        titulo: false,
        prefijo: false,
        caracteres: false,
        mensaje: false,
        logo: false,
        vencimiento: false,
        resolucion: false,
        negrita: false,
        small: false,
        letras: false,
        cop: false,
        t1: false,
        t2: false,
        t3: false,
        facturaNit: false,
        facturaBodega: false,
        facturaCcostos: false,
        facturaLprecios: false,
        facturacontrapartidas: false,
        facturaresolucion: false,
        cuentasdocumento: false,
        contrapartidasadicionales: false,
        isElectronico: false,
        nocontable: false,
      },
    };
  },
  computed: {
    ...mapState(["empresa", "cuentas", "nits", "bodegas"]),
    infoempresa() {
      return this.empresa._id;
    },
    cuentas1() {
      return functions.order(this.cuentas, "codigo");
    },
    contrapartidas() {
      let returned = [];
      if (this.visibility.contrapartidasadicionales) {
        if (this.comprobante[this.comprobante.estructura]) {
          returned =
            this.comprobante[this.comprobante.estructura].contrapartidas;
        }
      }
      return returned;
    },
  },
  methods: {
    estruct(nv) {
      if (nv === "comercialfra") {
        this.comprobante.estructura = "comercial";
        this.comprobante.esfactura = true;
        this.visibility.cuenta = true;
        this.visibility.tipo = true;
        this.visibility.titulo = true;
        this.visibility.prefijo = true;
        this.visibility.caracteres = true;
        this.visibility.mensaje = true;
        this.comprobante.aux = true;
        this.visibility.logo = true;
        this.visibility.vencimiento = true;
        this.visibility.resolucion = true;
        this.visibility.negrita = true;
        this.visibility.small = true;
        this.visibility.letras = true;
        this.visibility.cop = true;
        this.visibility.t1 = true;
        this.visibility.t2 = true;
        this.visibility.t3 = false;
        this.visibility.facturaNit = false;
        this.visibility.facturaBodega = false;
        this.visibility.facturaCcostos = false;
        this.visibility.facturaLprecios = false;
        this.visibility.facturacontrapartidas = false;
        this.visibility.facturaresolucion = false;
        this.visibility.cuentasdocumento = true;
        this.visibility.contrapartidasadicionales = false;
        this.visibility.isElectronico = true;
        this.visibility.nocontable = false;
      } else if (nv === "comercial") {
        this.comprobante.estructura = "comercial";
        this.comprobante.esfactura = false;
        this.visibility.cuenta = true;
        this.visibility.tipo = true;
        this.visibility.titulo = true;
        this.visibility.prefijo = true;
        this.visibility.caracteres = true;
        this.visibility.mensaje = true;
        this.comprobante.aux = true;
        this.visibility.logo = false;
        this.visibility.vencimiento = false;
        this.visibility.resolucion = false;
        this.visibility.negrita = false;
        this.visibility.small = false;
        this.visibility.letras = false;
        this.visibility.cop = false;
        this.visibility.t1 = false;
        this.visibility.t2 = false;
        this.visibility.t3 = false;
        this.visibility.facturaNit = false;
        this.visibility.facturaBodega = false;
        this.visibility.facturaCcostos = false;
        this.visibility.facturaLprecios = false;
        this.visibility.facturacontrapartidas = false;
        this.visibility.facturaresolucion = false;
        this.visibility.cuentasdocumento = true;
        this.visibility.contrapartidasadicionales = false;
        this.visibility.isElectronico = false;
        this.visibility.nocontable = false;
      } else if (nv === "contable") {
        this.comprobante.estructura = nv;
        this.comprobante.esfactura = false;
        this.visibility.cuenta = false;
        this.visibility.tipo = false;
        this.visibility.titulo = false;
        this.visibility.prefijo = false;
        this.visibility.caracteres = false;
        this.visibility.mensaje = false;
        this.comprobante.aux = false;
        this.visibility.logo = false;
        this.visibility.vencimiento = false;
        this.visibility.resolucion = false;
        this.visibility.negrita = false;
        this.visibility.small = false;
        this.visibility.letras = false;
        this.visibility.cop = false;
        this.visibility.t1 = false;
        this.visibility.t2 = false;
        this.visibility.t3 = false;
        this.visibility.facturaNit = false;
        this.visibility.facturaBodega = false;
        this.visibility.facturaCcostos = false;
        this.visibility.facturaLprecios = false;
        this.visibility.facturacontrapartidas = false;
        this.visibility.facturaresolucion = false;
        this.visibility.cuentasdocumento = false;
        this.visibility.contrapartidasadicionales = false;
        this.visibility.isElectronico = false;
        this.visibility.nocontable = false;
      } else if (nv === "inventario") {
        this.comprobante.estructura = nv;
        this.comprobante.esfactura = false;
        this.visibility.cuenta = true;
        this.visibility.tipo = true;
        this.visibility.titulo = true;
        this.visibility.prefijo = true;
        this.visibility.caracteres = true;
        this.visibility.mensaje = true;
        this.comprobante.aux = true;
        this.visibility.logo = false;
        this.visibility.vencimiento = false;
        this.visibility.resolucion = false;
        this.visibility.negrita = false;
        this.visibility.small = false;
        this.visibility.letras = false;
        this.visibility.cop = false;
        this.visibility.t1 = false;
        this.visibility.t2 = false;
        this.visibility.t3 = false;
        this.visibility.facturaNit = false;
        this.visibility.facturaBodega = false;
        this.visibility.facturaCcostos = false;
        this.visibility.facturaLprecios = false;
        this.visibility.facturacontrapartidas = false;
        this.visibility.facturaresolucion = false;
        this.visibility.cuentasdocumento = true;
        this.visibility.contrapartidasadicionales = true;
        this.visibility.isElectronico = false;
        this.visibility.nocontable = false;
      } else if (nv === "factura") {
        this.comprobante.estructura = nv;
        this.comprobante.esfactura = false;
        this.visibility.cuenta = true;
        this.visibility.tipo = true;
        this.visibility.titulo = true;
        this.visibility.prefijo = true;
        this.visibility.caracteres = true;
        this.visibility.mensaje = true;
        this.comprobante.aux = true;
        this.visibility.logo = true;
        this.visibility.vencimiento = true;
        this.visibility.resolucion = true;
        this.visibility.negrita = true;
        this.visibility.small = true;
        this.visibility.letras = false;
        this.visibility.cop = false;
        this.visibility.t1 = false;
        this.visibility.t2 = false;
        this.visibility.t3 = true;
        this.visibility.facturaNit = true;
        this.visibility.facturaBodega = true;
        this.visibility.facturaCcostos = true;
        this.visibility.facturaLprecios = true;
        this.visibility.facturacontrapartidas = true;
        this.visibility.facturaresolucion = true;
        this.visibility.cuentasdocumento = false;
        this.visibility.contrapartidasadicionales = true;
        this.visibility.isElectronico = true;
        this.visibility.nocontable = true;
      } else {
        this.comprobante.estructura = nv;
        this.comprobante.esfactura = false;
        this.visibility.cuenta = false;
        this.visibility.tipo = false;
        this.visibility.titulo = false;
        this.visibility.prefijo = false;
        this.visibility.caracteres = false;
        this.visibility.mensaje = false;
        this.comprobante.aux = false;
        this.visibility.logo = false;
        this.visibility.vencimiento = false;
        this.visibility.resolucion = false;
        this.visibility.negrita = false;
        this.visibility.small = false;
        this.visibility.letras = false;
        this.visibility.cop = false;
        this.visibility.t1 = false;
        this.visibility.t2 = false;
        this.visibility.facturaNit = false;
        this.visibility.facturaBodega = false;
        this.visibility.facturaCcostos = false;
        this.visibility.facturaLprecios = false;
        this.visibility.facturacontrapartidas = false;
        this.visibility.cuentasdocumento = false;
        this.visibility.contrapartidasadicionales = false;
        this.visibility.isElectronico = false;
        this.visibility.nocontable = false;
      }
    },
    onFileChange(e) {
      const _this = this;
      let task;
      const files = e.target.files;
      if (files.length) {
        const file = files[0];
        task = _this.$fire.imgproduct(file);
        _this.avaceupload = 10;
        task.on(
          "state_changed",
          (snapshot) => {
            const porcentaje =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            if (porcentaje > 10) {
              _this.avaceupload = porcentaje;
            }
          },
          (err) => {
            console.log("error subiendo el archivo", err);
          },
          async () => {
            try {
              const url = await task.snapshot.ref.getDownloadURL();
              _this.urlimg = url;
              _this.comprobante.urlimg = url;
              _this.avaceupload = 0;
            } catch (err) {
              console.log("ocurrio un error", err);
            }
          }
        );
      }
    },
    async addContrapartida() {
      try {
        if (this.comprobante[this.comprobante.estructura]) {
          this.comprobante[this.comprobante.estructura].contrapartidas.push(
            this.contrapartidaSelected
          );
        } else {
          this.$set(this.comprobante, this.comprobante.estructura, {});
          this.$set(
            this.comprobante[this.comprobante.estructura],
            "contrapartidas",
            []
          );
          this.comprobante[this.comprobante.estructura].contrapartidas.push(
            this.contrapartidaSelected
          );
        }
        this.comprobante.estructura = this.comprobante.estructura1;
        const result = await apiServices.put(
          `/comprobante/${this.$route.params.id}`,
          this.comprobante
        );
        if (result.data) {
          this.$store.dispatch("notify", {
            message: "Contrapartida agregada.",
            type: "is-primary",
            position: "top-center",
          });
        }
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrió un error, no se pudo agregar la contrapartida.",
          type: "is-danger",
          position: "top-center",
        });
        console.log(err);
      }
    },
    clickshowcontrapartidas() {
      if (this.showAddContrapartida) {
        this.showAddContrapartida = false;
      } else {
        this.showAddContrapartida = true;
      }
    },
    async deleteContrapartida(idcontrapartida) {
      try {
        const _this = this;
        for (
          let index = 0;
          index <
          _this.comprobante[_this.comprobante.estructura].contrapartidas.length;
          index++
        ) {
          const contrapartida =
            _this.comprobante[_this.comprobante.estructura].contrapartidas[
              index
            ];
          if (contrapartida._id === idcontrapartida) {
            _this.comprobante[
              _this.comprobante.estructura
            ].contrapartidas.splice(index, 1);
          }
        }
        const result = await apiServices.put(
          `/comprobante/${this.$route.params.id}`,
          this.comprobante
        );
        if (result.data) {
          this.$store.dispatch("notify", {
            message: "Documento actualizado.",
            type: "is-primary",
            position: "top-center",
          });
        }
      } catch (err) {
        this.$store.dispatch("notify", {
          message: "Ocurrio un problema y no se pudo actualizar el documento.",
          type: "is-danger",
          position: "top-center",
        });
        console.log(err);
      }
    },
    dateTostring(date) {
      let datetext = date.toString();
      if (datetext.length === 1) {
        datetext = `0${datetext}`;
      }
      return datetext;
    },
    async finddocumentbyid() {
      let datestart = "";
      let datefinal = "";
      try {
        const result = await apiServices.get(
          `/comprobante/${this.$route.params.id}`
        );
        if (result.data) {
          this.estruct(result.data.estructura);
          this.comprobante = result.data;
          if (!this.comprobante.factura) {
            this.comprobante.factura = {
              nit: {},
              bodega: {},
              ccostos: {},
              lprecios: {},
              resolucion: "",
              piefactura: "",
              contrapartidas: [],
            };
          }
          if (
            this.comprobante.estructura === "comercial" &&
            this.comprobante.esfactura
          ) {
            this.comprobante.estructura1 = "comercialfra";
            if (this.comprobante.isElectronico) {
              if (this.comprobante.resoluciodatestart) {
                datestart = new Date(this.comprobante.resoluciodatestart);
                datestart = `${datestart.getFullYear()}-${this.dateTostring(
                  datestart.getMonth() + 1
                )}-${this.dateTostring(datestart.getDate() + 1)}`;
                this.comprobante.resoluciodatestart = datestart;
              }
              if (this.comprobante.resoluciodatefinal) {
                datefinal = new Date(this.comprobante.resoluciodatefinal);
                datefinal = `${datefinal.getFullYear()}-${this.dateTostring(
                  datefinal.getMonth() + 1
                )}-${this.dateTostring(datefinal.getDate() + 1)}`;
                this.comprobante.resoluciodatefinal = datefinal;
              }
            }
          } else {
            this.comprobante.estructura1 = this.comprobante.estructura;
          }
          if (this.comprobante.estructura === "factura") {
            this.comprobante.facturanit1 = this.comprobante.factura.nit._id;
            this.comprobante.facturabodega1 =
              this.comprobante.factura.bodega._id;
            this.comprobante.facturaccostos1 =
              this.comprobante.factura.ccostos._id;
            this.comprobante.facturalprecios1 =
              this.comprobante.factura.lprecios.codigo;
            if (this.comprobante.isElectronico) {
              if (this.comprobante.resoluciodatestart) {
                datestart = new Date(this.comprobante.resoluciodatestart);
                datestart = `${datestart.getFullYear()}-${this.dateTostring(
                  datestart.getMonth() + 1
                )}-${this.dateTostring(datestart.getDate() + 1)}`;
                this.comprobante.resoluciodatestart = datestart;
              }
              if (this.comprobante.resoluciodatefinal) {
                datefinal = new Date(this.comprobante.resoluciodatefinal);
                datefinal = `${datefinal.getFullYear()}-${this.dateTostring(
                  datefinal.getMonth() + 1
                )}-${this.dateTostring(datefinal.getDate() + 1)}`;
                this.comprobante.resoluciodatefinal = datefinal;
              }
            }
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async findcuentasdocumento() {
      try {
        const result = await apiServices.get(
          `/cuentas/dcto/${this.$route.params.id}`
        );
        if (result.data) {
          let ctadcto = result.data.map(function (k) {
            k.codigo = k.cuenta.codigo;
            return k;
          });
          this.cuentasdcto = functions.order(ctadcto, "codigo");
        }
      } catch (err) {
        console.log(err);
      }
    },
    async deleteCuentadocumento(cuentaid) {
      try {
        const result = await apiServices.delete(`/cuentasdcto/${cuentaid}`);
        if (result.data) {
          this.findcuentasdocumento();
        }
      } catch (err) {
        this.$store.dispatch("notify", {
          message:
            "Ocurrió un error, no se pudo borrar la cuenta del documento.",
          type: "is-danger",
          position: "top-center",
        });

        console.log(err);
      }
    },
    async functionlprecios() {
      const _this = this;
      if (this.empresa.modulos && this.empresa.modulos.pventa) {
        const lpr = Object.keys(this.empresa.modulos.pventa.listas);
        lpr.forEach(function (k) {
          _this.lprecios.push({
            codigo: k,
            nombre: _this.empresa.modulos.pventa.listas[parseInt(k)],
          });
        });
      } else {
        this.$store.dispatch("notify", {
          message:
            "La empresa no tiene configurados los modulos. Ponerse en contacto con soporte",
          type: "is-danger",
          position: "top-center",
        });
      }
    },
    async findCCostos() {
      try {
        this.listaCCostos = [];
        const result = await apiServices.get(`/ccostos`);
        this.listaCCostos = result.data;
      } catch (err) {
        console.log(err);
      }
    },
    async saveDocumento() {
      try {
        const comprobantetosaved = {};
        const _this = this;
        if (!this.comprobante.nombre) {
          this.$store.dispatch("notify", {
            message: "Debe diligenciar el nombre.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.comprobante.codigo) {
          this.$store.dispatch("notify", {
            message: "Debe diligenciar el código",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.comprobante.consecutivo) {
          this.$store.dispatch("notify", {
            message: "Debe diligenciar el consecutivo",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.comprobante.consecutivoc) {
          this.$store.dispatch("notify", {
            message: "Debe diligenciar el consecutivo del modulo contable",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (!this.comprobante.estructura1) {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar una estructura",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (_this.visibility.cuenta && !this.comprobante.cuenta) {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar una contrapartida",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (_this.visibility.tipo && !this.comprobante.tipo) {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar la naturaleza de la contrapartida",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (_this.visibility.titulo && !this.comprobante.titulo) {
          this.$store.dispatch("notify", {
            message: "Debe diligenciar un título en impresión de documento",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (_this.visibility.vencimiento && !this.comprobante.vencimiento) {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar un vencimiento",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (_this.visibility.facturaNit && !this.comprobante.facturanit1) {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar un tercero predeterminado",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (
          _this.visibility.facturaBodega &&
          !this.comprobante.facturabodega1
        ) {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar una bodega predeterminada",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (
          _this.visibility.facturaCcostos &&
          !this.comprobante.facturaccostos1
        ) {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar un centro de costos predeterminado",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (
          _this.visibility.facturaLprecios &&
          !this.comprobante.facturalprecios1
        ) {
          this.$store.dispatch("notify", {
            message: "Debe seleccionar una lista de precios predeterminada",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (
          _this.comprobante.isElectronico &&
          !this.comprobante.resolucionelect
        ) {
          this.$store.dispatch("notify", {
            message:
              "Debe ingresar el número de la resolución de facturación electrónica",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (
          _this.comprobante.isElectronico &&
          !this.comprobante.resoluciodatestart
        ) {
          this.$store.dispatch("notify", {
            message:
              "Debe ingresar la fecha de inicio de la resolución de facturación.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (
          _this.comprobante.isElectronico &&
          !this.comprobante.resoluciodatefinal
        ) {
          this.$store.dispatch("notify", {
            message:
              "Debe ingresar la fecha final de la resolución de facturación.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (
          _this.comprobante.isElectronico &&
          !this.comprobante.resolucionrangestart
        ) {
          this.$store.dispatch("notify", {
            message:
              "Debe ingresar el rango inicial de la resolución de facturación.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        if (
          _this.comprobante.isElectronico &&
          !this.comprobante.resolucionrangefinal
        ) {
          this.$store.dispatch("notify", {
            message:
              "Debe ingresar el rango final de la resolución de facturación.",
            type: "is-warning",
            position: "top-center",
          });
          return false;
        }
        comprobantetosaved.nombre = this.comprobante.nombre;
        comprobantetosaved.codigo = this.comprobante.codigo;
        comprobantetosaved.consecutivo = this.comprobante.consecutivo;
        comprobantetosaved.consecutivoc = this.comprobante.consecutivoc;
        comprobantetosaved.estructura = this.comprobante.estructura;
        comprobantetosaved.automaticdate = this.comprobante.automaticdate;
        comprobantetosaved.nocontable = this.comprobante.nocontable;
        if (this.visibility.cuenta) {
          comprobantetosaved.cuenta = this.comprobante.cuenta;
        }
        if (this.visibility.tipo) {
          comprobantetosaved.tipo = this.comprobante.tipo;
        }
        if (this.visibility.titulo) {
          comprobantetosaved.titulo = this.comprobante.titulo;
        }
        if (this.visibility.prefijo) {
          comprobantetosaved.prefijo = this.comprobante.prefijo;
        }
        if (this.visibility.caracteres) {
          comprobantetosaved.caracteres = this.comprobante.caracteres;
        }
        if (this.visibility.mensaje) {
          comprobantetosaved.mensaje = this.comprobante.mensaje;
        }
        if (this.visibility.logo) {
          comprobantetosaved.logo = this.comprobante.logo;
          comprobantetosaved.urlimg = this.comprobante.urlimg;
        }
        if (this.visibility.vencimiento) {
          comprobantetosaved.vencimiento =
            this.comprobante.vencimiento === "1"
              ? 0
              : this.comprobante.vencimiento;
        }
        if (this.visibility.resolucion) {
          comprobantetosaved.resolucion = this.comprobante.resolucion;
        }
        if (this.visibility.negrita) {
          comprobantetosaved.negrita = this.comprobante.negrita;
        }
        if (this.visibility.small) {
          comprobantetosaved.small = this.comprobante.small;
        }
        if (this.visibility.letras) {
          comprobantetosaved.letras = this.comprobante.letras;
        }
        if (this.visibility.cop) {
          comprobantetosaved.cop = this.comprobante.cop;
        }
        if (this.visibility.t1) {
          comprobantetosaved.t1 = this.comprobante.t1;
        }
        if (this.visibility.t2) {
          comprobantetosaved.t2 = this.comprobante.t2;
        }
        if (this.visibility.t3) {
          comprobantetosaved.t3 = this.comprobante.t3;
        }
        if (this.visibility.isElectronico) {
          comprobantetosaved.isElectronico = this.comprobante.isElectronico;
          if (this.comprobante.isElectronico) {
            comprobantetosaved.isPrueba = this.comprobante.isPrueba;
            comprobantetosaved.resolucionelect =
              this.comprobante.resolucionelect;
            comprobantetosaved.resoluciodatestart =
              this.comprobante.resoluciodatestart;
            comprobantetosaved.resoluciodatefinal =
              this.comprobante.resoluciodatefinal;
            comprobantetosaved.resolucionrangestart =
              this.comprobante.resolucionrangestart;
            comprobantetosaved.resolucionrangefinal =
              this.comprobante.resolucionrangefinal;
            comprobantetosaved.ctecnica = this.comprobante.ctecnica;
            comprobantetosaved.idfra = this.comprobante.idfra;
            comprobantetosaved.tipodocumento = this.comprobante.tipodocumento;
          }
        }
        if (this.visibility.facturaNit) {
          for (let index = 0; index < this.nits.length; index++) {
            if (_this.nits[index]._id === _this.comprobante.facturanit1) {
              _this.comprobante.factura.nit = _this.nits[index];
              break;
            }
          }
          for (let index = 0; index < this.bodegas.length; index++) {
            if (_this.bodegas[index]._id === _this.comprobante.facturabodega1) {
              _this.comprobante.factura.bodega = _this.bodegas[index];
              break;
            }
          }
          for (let index = 0; index < this.listaCCostos.length; index++) {
            if (
              _this.listaCCostos[index]._id ===
              _this.comprobante.facturaccostos1
            ) {
              _this.comprobante.factura.ccostos = _this.listaCCostos[index];
              break;
            }
          }
          for (let index = 0; index < this.lprecios.length; index++) {
            if (
              _this.lprecios[index].codigo ===
              _this.comprobante.facturalprecios1
            ) {
              _this.comprobante.factura.lprecios = _this.lprecios[index];
              break;
            }
          }
          comprobantetosaved.factura = {};
          comprobantetosaved.factura.nit = this.comprobante.factura.nit;
          comprobantetosaved.factura.bodega = this.comprobante.factura.bodega;
          comprobantetosaved.factura.ccostos = this.comprobante.factura.ccostos;
          comprobantetosaved.factura.lprecios =
            this.comprobante.factura.lprecios;
          comprobantetosaved.factura.resolucion =
            this.comprobante.factura.resolucion;
          comprobantetosaved.factura.piefactura =
            this.comprobante.factura.piefactura;
          comprobantetosaved.factura.contrapartidas =
            this.comprobante.factura.contrapartidas;
        }
        if (this.comprobante.estructura === "inventario") {
          comprobantetosaved.inventario = {
            contrapartidas: this.comprobante.inventario
              ? this.comprobante.inventario.contrapartidas
              : [],
          };
        }
        let result;
        if (this.$route.params.id) {
          result = await apiServices.put(
            `/comprobante/${this.$route.params.id}`,
            comprobantetosaved
          );
        } else {
          result = await apiServices.post(
            `/createcomprobante`,
            comprobantetosaved
          );
        }
        if (result.data && result.data.message) {
          this.$store.dispatch("notify", {
            message: `No se guardo el comprobante. ${result.data.message}`,
            type: "is-danger",
            position: "top-center",
          });
          return false;
        } else {
          this.$store.dispatch("notify", {
            message: `Documento editado con éxito`,
            type: "is-primary",
            position: "top-center",
          });
          this.$router.push({
            name: "configurations.document",
          });
        }
      } catch (err) {
        console.log(err);
        this.$store.dispatch("notify", {
          message:
            "Ocurrio un error guardando el documento. Intentelo más tarde.",
          type: "is-danger",
          position: "top-center",
        });
      }
    },
  },
  watch: {
    infoempresa(nv, ov) {
      if (nv !== "no id") {
        this.functionlprecios();
      }
    },
  },
  created() {
    this.findCCostos();
    if (this.empresa._id !== "no id") {
      this.functionlprecios();
    }
    if (this.$route.params.id) {
      this.iconbutton = "edit";
      this.textbutton = "Editar";
      this.finddocumentbyid();
      this.findcuentasdocumento();
      this.title = "Editar Documento";
      this.isedit = true;
    } else {
      this.iconbutton = "save";
      this.textbutton = "Guardar";
      this.title = "Crear Documento";
      this.isedit = false;
    }
  },
};
</script>


// WEBPACK FOOTER //
// src/components/configurations/document/Documentcreate.vue